import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function HotArticles() {
  const hotArticles = articles.filter((a) => a.isHot);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                <i className="ri-fire-line text-accent-500 mr-2"></i>
                热门爆料
              </h2>
              <p className="text-sm text-foreground-600 mt-1">全网最火爆的黑料资讯，吃瓜必看</p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {hotArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    title={article.title}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                      热门
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                    <span className="whitespace-nowrap">{article.publishDate}</span>
                    <span className="whitespace-nowrap">{article.readTime}阅读</span>
                    <span className="whitespace-nowrap">{article.author}</span>
                  </div>
                  <h3 className="text-foreground-950 font-semibold text-base mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-sm line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-4 mt-4 text-foreground-500 text-xs">
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-eye-line"></i>
                      {article.viewCount >= 10000 ? `${(article.viewCount / 10000).toFixed(1)}万` : article.viewCount}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-message-2-line"></i>
                      {article.commentCount}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}